import React from "react";
import { Steps, Button, message } from 'antd';
import Step1 from "./step1";
import Step2 from "./step2";
import Step3 from "./step3";
import Step4 from "./step4";
import Step5 from "./step5";
import './step.css'
const { Step } = Steps;
const steps = [
    {
      title: '核实账号',
      content: 'First-content',
    },
    {
      title: '验证选择',
      content: 'Second-content',
    },
    {
      title: '安全校验',
      content: 'Last-content',
    },
    {
      title: '设置密码',
      content: 'Last-content',
    },
    {
        title: '完成',
        content: 'Last-content',
      }
  ];
  export default function  Forgetpsw(){
    const [current, setCurrent] = React.useState(0);
    const [port,setport] = React.useState(1)
    const handlecamp = (step,value) => {
      console.log(step);
      console.log(value);
      setCurrent(step-1);
      setport(value)
    }
  
    const next = () => {
      setCurrent(current + 1);
    };
    const prev = () => {
      setCurrent(current - 1);
    };
    const step = [<Step1  next={next}/>,<Step2 handlecamp={handlecamp }  />,<Step3 port={port} prev={prev} next = {next}/>,<Step4 prev={prev} next = {next}/>,<Step5/>]
  
    return(
        <>
        <Steps style={{    width: "80%", margin: "auto"}} current={current}>
        {steps.map(item => (
          <Step key={item.title} title={item.title} />
        ))}
      </Steps>
      
      {/* <div className="steps-content">{steps[current].content}</div> */}
      <div className="steps-content">{step[current]}</div>
      {/* <div className="steps-action">
        {current < steps.length - 1 && (
          <Button type="primary" onClick={() => next()}>
            Next
          </Button>
        )}
        {current === steps.length - 1 && (
          <Button type="primary" onClick={() => message.success('Processing complete!')}>
            Done
          </Button>
        )}
        {current > 0 && (
          <Button style={{ margin: '0 8px' }} onClick={() => prev()}>
            Previous
          </Button>
        )}
      </div> */}
        </>
    )
} 